import type { UseFormReturn } from 'react-hook-form';
import type { IFieldElem } from '@models/IFormData';
import { FormulaManager } from './FormulaManager';

/**
 * Формулы над картой полей с подменяемым набором `variables` (условные переменные,
 * changeAction). Одна копия карты полей на вызывающего, а не на каждое выражение:
 * вычисления идут последовательно, поэтому набор подменяется перед каждым Init.
 * variables в выражении уже подставлены вызывающим: повторная подстановка изменила бы литералы.
 */
export const createVariablesFormula = (
    data: Record<string, IFieldElem>,
    formMethods?: UseFormReturn<any>,
    parentRow?: any,
) => {
    const variablesField: IFieldElem = { name: 'variables', value: undefined, index: -1 };
    let formulaData: Record<string, IFieldElem> | undefined;
    return (expression: string, variables: Record<string, unknown>) => {
        const formula = new FormulaManager(expression);
        variablesField.value = variables;
        formulaData ??= { ...data, variables: variablesField };
        formula.Init(formulaData, formMethods, parentRow, false);
        return formula;
    };
};
